import { gql } from "@apollo/client";

export const codesListQuery = gql`
    query CodesListAdmin($page: Int, $sort: SortInput, $activated: Boolean, $query: String) {
        licencesAdmin(page: $page, sort: $sort, activated: $activated, query: $query) {
            nodes {
                id
                code
                activatedAt
                activeFrom
                activeTill
                package {
                    name
                }
                createdAt
                type
            }
            totalCount
            nextPage
            previousPage
            totalPages
        }
    }
`;
